
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/industries/telco",
      function () {
        return require("private-next-pages/solutions/industries/telco.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/industries/telco"])
      });
    }
  